module.exports = __webpack_public_path__ + "img/图片1.e744196e.png";